import {
  GET_LANDING_PAGE_REQUEST,
  GET_THEMES,
} from '../../containers/landing-page/requests'
import { Field } from '../../global/types'

const snakeToCamel = (str: string) =>
  str.replace(/([-_][a-z])/g, group =>
    group.toUpperCase().replace('-', '').replace('_', ''),
  )

const deserializer = resource => {
  const newResource = {}

  Object.keys(resource).forEach(value => {
    newResource[snakeToCamel(value)] = resource[value]
  })

  return newResource
}

export const deserializeLandingPageContent = landingPageContent => {
  return {
    ...deserializer(landingPageContent),
  }
}

const mergeData = (data, resourceType, resource) => {
  return {
    ...data,
    [resourceType]: {
      ...data[resourceType],
      [resource.id]: resource,
    },
  }
}

export const normalizers = {
  // eslint-disable-next-line
  [GET_LANDING_PAGE_REQUEST]: (_: number, response: any) => {
    let data = {}

    const landingPageContents = response.landing_page_contents.map(
      landingPageContent => {
        // TODO: MOCK
        // eslint-disable-next-line no-param-reassign
        landingPageContent.fields = landingPageContent.fields
          .map(field => ({
            ...field,
            value: '',
            // This special cases for age will be addressed later in the Backend, but right now it's only needed for age fields
            type: field.name === 'age' ? 'radio' : 'string',
            settings:
              field.name === 'age'
                ? {
                    options: [
                      { label: 'Yes', value: 'yes' },
                      { label: 'No', value: 'no' },
                    ],
                  }
                : {},
          }))
          .sort((a, b) => a.orderIndex - b.orderIndex)

        data = mergeData(
          data,
          'languages',
          deserializer(landingPageContent.language),
        )

        data = mergeData(data, 'seos', deserializer(landingPageContent.seo))

        data = mergeData(
          data,
          'workflows',
          deserializer(landingPageContent.workflow),
        )

        const newLandingPageContent = {
          ...deserializer(landingPageContent),
          language: {
            id: landingPageContent.language.id,
            resource: 'languages',
          },
          fields: landingPageContent.fields.map((field: Field) => {
            data = mergeData(data, 'fields', deserializer(field))
            return {
              id: field.id,
              resource: 'fields',
            }
          }),
          vehicles: landingPageContent.vehicles.map(vehicle => {
            data = mergeData(data, 'vehicles', deserializer(vehicle))
            return {
              id: vehicle.id,
              resource: 'vehicles',
            }
          }),
          workflows: {
            id: landingPageContent.workflow.id,
            resource: 'workflows',
          },
          seo: {
            id: landingPageContent.seo.id,
            resource: 'seos',
          },
        }

        data = mergeData(data, 'landingPageContents', newLandingPageContent)

        return {
          resource: 'landingPageContents',
          id: landingPageContent.id,
        }
      },
    )

    data = mergeData(data, 'themes', deserializer(response.theme))

    data = mergeData(data, 'landingPages', {
      ...deserializer(response),
      theme: {
        resource: 'themes',
        id: response.theme.id,
      },
      landingPageContents,
    })

    return data
  },
  // eslint-disable-next-line
  [GET_THEMES]: (_: number, response: any) => {
    let data = {}
    if (response.themes) {
      response.themes.forEach(theme => {
        data = mergeData(data, 'themes', deserializer(theme))
      })
    }

    return data
  },
}
